var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideo = function SvgVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343754",
    fillRule: "nonzero",
    d: "M18.997 0H2.003A2.013 2.013 0 0 0 0 2.004v13.992C0 17.096.905 18 2.003 18h16.994A2.013 2.013 0 0 0 21 15.996V2.004A2.013 2.013 0 0 0 18.997 0zM7.01 2.004h2.003v2.003H7.01V2.004zM4.006 16.029H2.003v-2.004h2.003v2.004zm0-12.022H2.003V2.004h2.003v2.003zM9.014 16.03H7.01v-2.004h2.003v2.004zm4.975 0h-2.003v-2.004h2.003v2.004zm-5.977-4.007V6.01l5.977 3.005-5.977 3.006zm5.977-8.015h-2.003V2.004h2.003v2.003zm5.008 12.022h-2.003v-2.004h2.003v2.004zm0-12.022h-2.003V2.004h2.003v2.003z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video.0cb6a41a.svg";
export { ForwardRef as ReactComponent };